import { useAuth, useUser } from '@clerk/nextjs'
import { IconLock } from '@tabler/icons-react'

import { Button } from '../shared-components/BUI/Button'
import { Form } from '../shared-components/BUI/Form'
import { Modal } from '../shared-components/BUI/Modal'
import { Text } from '../shared-components/BUI/Text'
import { Flexbox } from '../shared-components/Flexbox'

import { PasswordUpdateContent } from '@/modules/account/PasswordUpdateContent'

export const UpdatePasswordModal = () => {
  const [passwordForm] = Form.useForm()
  const { isLoaded } = useAuth()
  const { user } = useUser()

  if (user?.passwordEnabled || !isLoaded) {
    return null
  }

  return (
    <Modal
      open={!user?.passwordEnabled && isLoaded}
      footer={
        <>
          <Button variant="primary" onClick={() => passwordForm.submit()}>
            Submit
          </Button>
        </>
      }
      centered
    >
      <Flexbox
        gap={'1rem'}
        alignItems="center"
        flexDirection="column"
        style={{ width: '100%' }}
      >
        <IconLock size={36} />
        <Text
          variant="body02"
          style={{ textAlign: 'center', maxWidth: '17rem' }}
        >
          Please set a password for your account to continue.
        </Text>
        <div style={{ width: '100%' }}>
          <PasswordUpdateContent passwordForm={passwordForm} />
        </div>
      </Flexbox>
    </Modal>
  )
}
